import React, { ChangeEvent } from 'react';
import { joiPasswordExtendCore } from 'joi-password';
import Joi from 'joi';

import Form from '../common/form';
import PasswordStrength from '../blocks/password-strength';
import Progress from '../themed/progress';

import * as userService from '../../services/userService';
import * as toastService from '../../services/toastService';
import * as utils from '../../utils/utilities';

import routes from '../../utils/routes';
import {
	MAX_PASSWORD_LENGTH,
	MIN_PASSWORD_LENGTH,
} from '../../utils/constants';

class ResetPasswordForm extends Form {
	state = {
		data: {
			oldPassword: '',
			newPassword: '',
			confirmPassword: '',
		},
		errors: {},
		loading: false,
		progress: 0,
		states: [],
		cities: [],
	};

	schema = {
		oldPassword: Joi.string().min(3).required().label('Old Password'),
		newPassword: Joi.extend(joiPasswordExtendCore)
			.string()
			.min(MIN_PASSWORD_LENGTH)
			.max(MAX_PASSWORD_LENGTH)
			.minOfSpecialCharacters(1)
			.minOfLowercase(1)
			.minOfUppercase(1)
			.minOfNumeric(1)
			.noWhiteSpaces()
			.required()
			.label('New Password'),
		confirmPassword: Joi.string()
			.valid(Joi.ref('newPassword'))
			.required()
			.label('Confirm Password')
			.messages({
				'any.only': 'Fields must match',
			}),
	};

	postData = async (): Promise<void> => {
		await userService.resetPassword(this.state.data, this.handleProgressChange);
		window.location.href = routes.dashboard.fullPath;
	};

	handlePasswordChange = async (event: ChangeEvent<HTMLInputElement>) => {
		await this.handleChange(event);

		const confirmPassword: string = event.target.value;
		const isMatch: boolean = this.state.data.newPassword === confirmPassword;

		if (isMatch) {
			const errors = { ...this.state.errors } as any;
			delete errors.confirmPassword;

			this.setState({ errors });
		}
	};

	doSubmit = (): void => {
		toastService.promise(this.postData(), {
			loading: 'Updating Password',
			success: 'Password Updated',
			error: utils.getErrorMessage,
		});
	};

	render() {
		return (
			<React.Fragment>
				<Progress progress={this.state.progress} />

				<div className="p-3 container-fluid">
					<form autoComplete="off" onSubmit={this.handleSubmit}>
						<h1 className="form-title">Change Your Password</h1>

						<div className="row">
							<div className="col">
								{this.renderInput({
									type: 'password',
									name: 'oldPassword',
									label: 'Old Password',
									placeholder: 'Enter Old Password',
								})}
							</div>

							<div className="col">
								{this.renderInput({
									type: 'password',
									name: 'newPassword',
									label: 'New Password',
									placeholder: 'Choose a Password',
								})}

								<PasswordStrength password={this.state.data.newPassword} />
							</div>

							<div className="col">
								{this.renderInput({
									type: 'password',
									name: 'confirmPassword',
									label: 'Confirm Password',
									placeholder: 'Confirm Your Chosen Password',
									onChange: this.handlePasswordChange,
								})}
							</div>
						</div>

						<div className="d-flex justify-content-end">
							{this.renderButton('Reset')}
						</div>
					</form>
				</div>
			</React.Fragment>
		);
	}
}

export default ResetPasswordForm;
